import { Button, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { APIS, URLS, SF_NOTI_LOGS_SRCH, SG_NOTI_LOGS_LIST, SETTINGS_MAP } from "@/tra/tancis/ptli/ewc/svr/services/EwciNotiLogsService";

/*
 * Server List
 * !== 서버 목록 ==!
 */
export const EWCI1001005Q = () => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015"],
    }); 
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "CGM0176" }, { area: "comnCd", comnCd: "COM0024" },{ area: "comnCd", comnCd: "PTL0022" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        notiLogsSrch: useForm({
            defaultSchema: SF_NOTI_LOGS_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const grid = {
        notiLogsList: useGrid({
            defaultSchema: SG_NOTI_LOGS_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // et the Server list. !== 서버 목록을 조회한다.==!
        getNotiLogsList: useFetch({
            api: (page = grid.notiLogsList.page) => 
               APIS.getNotiLogsList(form.notiLogsSrch.getValues(), page, grid.notiLogsList.size),
            
            enabled: comnUtils.isEmpty(form.notiLogsSrch.errors) && form.notiLogsSrch.isSubmitted,
            key: [grid.notiLogsList.page, grid.notiLogsList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.notiLogsSrch.getValues(),
                    page: grid.notiLogsList.page,
                    size: grid.notiLogsList.size,
                });



            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        btnSrchClick: (page: number = 0) => {

            if (!comnUtils.isEmpty(form.notiLogsSrch.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }


            form.notiLogsSrch.handleSubmit(
                () => {
                    grid.notiLogsList.setPage(page);
                    fetch.getNotiLogsList.fetch(page);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
    };

    const render = {
        cell: {
            notiNm: (props: any) => {
                const { rowValues, value } = props;
                return <Link to={`${URLS.ewci1001006q}/${rowValues.notiSendUuid}`}>{value}</Link>;
            },

            notiTpValue: (props: any) => {
                const { rowValues, value } = props;

                return SETTINGS_MAP[Number(value)];
            },
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        // fetch.getNotiLogsList.fetch();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.notiLogsSrch.schema.bsopClsfCd}></Group.Control>
                            <Group.Control {...form.notiLogsSrch.schema.notiSendStatCd}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.notiLogsSrch.schema.notiId}></Group.Control>
                            <Group.Control {...form.notiLogsSrch.schema.notiTpValue}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.notiLogsSrch.schema.srchDt}></Group.Control>
                        </Group.Row>

                        
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.notiLogsSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.btnSrchClick();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.notiLogsList.grid}
                            data={fetch.getNotiLogsList.data?.logList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
